import {Component, Input, OnInit} from '@angular/core';
import {AddressModel} from '../../../../core-logic/models/address/address-model';
import {NavigationExtras, Router} from '@angular/router';

@Component({
  selector: 'app-address-item',
  templateUrl: './address-item.component.html',
  styleUrls: ['./address-item.component.scss'],
})
export class AddressItemComponent implements OnInit {
  @Input() disableLinks = false;
  @Input() address: AddressModel;
  @Input() route: { commands: any[]; extras?: NavigationExtras } = {commands: []};
  constructor(
    private router: Router
  ) { }

  ngOnInit() {}

  goToRoute() {
    this.router.navigate(this.route.commands, this.route.extras ?? {state: this.address});
  }

  isDisable(uiEvent: UIEvent) {
    if (this.disableLinks) {
      uiEvent.preventDefault();
    }
  }
}
